module.exports = __webpack_public_path__ + "zvetseni-prsou_16_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_16_before.jpg
// module id = 1306
// module chunks = 0